<app-image-box-link
    (onClickEmit)="onClickEmit.emit()"
    [border]="input_border$$()"
    [noClick]="input_noClick$$()"
    [size]="input_size$$()"
    [tooltip]="input_tooltip$$()"
    [tooltipPosition]="input_tooltipPosition$$()"
    [url]="input_url$$() ?? ''"
/>
